import { makeStyles } from "@fluentui/react-components";

export const useSuggestionMoreLoaderStyles = makeStyles({
  container: {
    textAlign: "center",
    paddingBottom: "20px",
  },
  button: {
    marginTop: "10px",
  },
});
